import React from "react";
import Header from "../sections/Header";
import Sidebar from "../sections/Sidebar";
import { encStorage } from "../hooks/encStorage";
import { GET_FINANCIALS } from "../services/Apis";
import axios from "axios";
import { useEffect, useState } from "react";

const Liquidationrules = () => {
  const [SidebarState, setSidebarState] = useState(false);

  const updateSidebarState = (newState) => {
    setSidebarState(newState);
  };

  const user = {
    id: encStorage.getItem("id"),
    name: encStorage.getItem("name"),
    client_code: encStorage.getItem("client_code"),
    id: encStorage.getItem("id"),
  };
  return (
    <>
      <Header updateState={updateSidebarState} />
      <div id="layoutSidenav">
        <Sidebar props={SidebarState} />
        <div id="layoutSidenav_content">
          <div className="container mt-3">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <h2 className="text-center mb-3 text-primary">
                  Liquidation Rules
                </h2>
                <div className="card shadow border-0">
                  <div className="card-body p-2">
                    <img
                      src={"/images/liquidation-rules-1.jpg"}
                      className="w-100"
                      alt="Liquidation Rules"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Liquidationrules;
